module.exports = __webpack_public_path__ + "static/media/wardah.7b046bb9.jpg";